<template>
    <div>
        <v-container fluid grid-list-xl pt-0 px-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh
                                @invoke-method="dbGetPermissionTemplate(true)"
                            ></bc-btn-refresh>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <v-layout>
                    <!-- permissions column -->
                        <v-flex xs12>
                            <bc-autocomplete
                                :focus="true"
                                v-model="login_type"
                                :items="login_types"
                                item-text="login_type"
                                item-value="login_type_id"
                                @change="selectTemplate($event)"
                                return-object
                                :label="$t('lang.select_login_type_base')"
                                no-data-text="No data to show"
                                class="pt-0"
                                hide-details
                            >
                                <template slot="item" slot-scope="data">
                                    {{ data.item.login_type | capitalize }}
                                </template>
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.login_type | capitalize }}
                                </template>
                            </bc-autocomplete>
                            <v-layout column>
                                <v-flex pb-0 v-if="hasPerm('configuration.update')">
                                    <div>
                                        <v-layout row>
                                            <v-flex xs7 :py-0="$bp.smallScreen" mr-3 :pt-3="$bp.smallScreen" :style="!$bp.smallScreen ? 'height: 38px;' : null">
                                                <v-btn
                                                    v-if="currentTemplate.length != 0"
                                                    depressed
                                                    color="success"
                                                    class="ma-0 pa-0"
                                                    @mouseup.left="updatePermissions()"
                                                    :disabled="!changed"
                                                >
                                                    {{$t('lang.save_template')}}
                                                </v-btn>
                                            </v-flex>
                                            <v-flex xs5 :py-0="$bp.smallScreen" :pt-3="$bp.smallScreen" pl-0 :style="!$bp.smallScreen ? 'height: 38px;' : null">
                                                <v-btn
                                                    v-if="currentTemplate.length != 0"
                                                    depressed
                                                    color="error"
                                                    class="ma-0 pa-0"
                                                    @mouseup.left="undoPermissionChanges()"
                                                    :disabled="!changed"
                                                >
                                                    {{$t('lang.undo_changes')}}
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-flex>
                                <v-flex mt-3 :class="{ 'prevent-click': !hasPerm('configuration.update') }">
                                    <div>
                                        <v-flex class="text-center grey--text mt-0" v-if="currentTemplate.length == 0">{{$t('lang.select_login_type')}}</v-flex>
                                        <v-flex
                                            v-for="(mod, index) in currentTemplate"
                                            style="overflow:hidden"
                                            class="py-0"
                                            :key="index"
                                            :px-0="$bp.smallScreen"
                                            :class="[!$bp.smallScreen ? 'hoverable' : '', index != currentTemplate.length - 1 ? 'border-bottom-1' : '']"
                                        >
                                            <v-layout :column="$bp.smallScreen">
                                                <v-flex xs2 class="my-auto px-3" :pt-4="$bp.smallScreen" :pb-0="$bp.smallScreen">
                                                    <b>{{ mod.module | start_case }}</b>
                                                </v-flex>
                                                <v-flex xs10  :class="$bp.smallScreen ? 'pt-1 pb-3' : 'py-3'">
                                                    <bc-autocomplete
                                                        v-model="updatedPermissions[mod.module_id]"
                                                        :items="allPermissionsFiltered[mod.module_id]"
                                                        item-value="value"
                                                        item-text="text"
                                                        :label="hasPerm('configuration.update') ? $t('lang.edit_permissions') : 'None'"
                                                        class="ma-0 pa-0"
                                                        multiple
                                                        @change="checkIfChanged()"
                                                        chips
                                                        no-data-text="No data to show"
                                                        hide-details
                                                        single-line
                                                        full-width
                                                        :readonly="!hasPerm('configuration.update')"
                                                    >
                                                        <template slot="selection" slot-scope="data">
                                                            <v-chip :selected="data.selected" color="black" outline class="chip--select-multi chip-break-word">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title style="max-width: 300px;">{{ data.item.text }}</v-list-tile-title>
                                                                </v-list-tile-content>
                                                            </v-chip>
                                                        </template>
                                                    </bc-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            companies: [],
            currentCompany: {},
            isOwner: null,
            allCompanies: [],
            companyToAdd: [],
            component_loader: false,
            currentPermissions: [],
            allPermissions: null,
            allPermissionsFiltered: [],
            addCompanyDialog: false,
            removeCompanyDialog: false,
            currentCompanyId: null,
            currentCompanyName: null,
            companies: [],
            updatedPermissions: {},
            currentTemplate: [],
            changed: false,
            permsToWatch: {},
            settings: {
                maxScrollbarLength: 150,
            },
            companies_body: {
                user_id: null,
            },
            scrollBarHeight: "",
            login_type: null,
            mobile_list: [{ title: this.$t("lang.refresh"), action: "dbGetPermissionTemplate", params: [true] }],
            dbGetPermissionTemplate: _.debounce(this.getPermissionTemplate, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        if (store.getters.login_types == null) {
            store
                .dispatch("fetchLoginType", {
                    url: "login_types",
                    method: "get",
                    stateProperty: "login_types",
                    dataProperty: "app_login_types",
                    commit: true,
                    localStorage: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        next((vm) => {
                            if (to.params.id) {
                                let current = _.find(vm.login_types, function(o) {
                                    return o.login_type_id == to.params.id;
                                });
                                if (current) {
                                    vm.login_type = current.login_type_id;
                                }
                                vm.getPermissionTemplate();
                            } else {
                                vm.resetCurrent();
                                vm.finishLoader();
                            }
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            next((vm) => {
                if (to.params.id) {
                    let current = _.find(vm.login_types, function(o) {
                        return o.login_type_id == to.params.id;
                    });
                    if (current) {
                        vm.login_type = current.login_type_id;
                    }
                    vm.getPermissionTemplate();
                } else {
                    vm.resetCurrent();
                    vm.finishLoader();
                }
            });
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (store.getters.login_types == null) {
            this.$store
                .dispatch("fetchLoginType", {
                    url: "login_types",
                    method: "get",
                    stateProperty: "login_types",
                    dataProperty: "app_login_types",
                    commit: true,
                    localStorage: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        if (to.params.id) {
                            let current = _.find(this.login_types, function(o) {
                                return o.login_type_id == to.params.id;
                            });
                            if (current) {
                                this.login_type = current.login_type_id;
                            }
                            this.getPermissionTemplate();
                        } else {
                            this.resetCurrent();
                            this.finishLoader();
                        }
                        next();
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            next();
            if (to.params.id) {
                let current = _.find(this.login_types, function(o) {
                    return o.login_type_id == to.params.id;
                });
                if (current) {
                    this.login_type = current.login_type_id;
                }
                this.getPermissionTemplate();
            } else {
                this.resetCurrent();
                this.finishLoader();
            }
        }
    },
    computed: {
        ...mapGetters(["person", "login_types"]),
        returnFilteredPerms() {
            if (this.allPermissions != null) {
                //return a new array with only the permissions the user has
                this.allPermissions.forEach((mod, index) => {
                    if (mod.permission_functions) {
                        this.currentPermissions[index] = { ...mod };
                        this.currentPermissions[index].permission_functions = mod.permission_functions.filter((permission) => permission.has_permission == 1);
                    }
                });
                return this.currentPermissions;
            }
        },
    },
    methods: {
        selectTemplate(temp) {
            this.$nextTick(() => {
                if (temp) {
                    this.login_type = temp.login_type_id;
                    this.$router.push({ name: "settings_permission_templates", params: { id: temp.login_type_id } });
                }
            });
        },
        resetCurrent() {
            this.currentTemplate = [];
            this.login_type = null;
        },
        getPermissionTemplate(start_loader = false) {
            if (start_loader) this.startLoader();
            if (this.login_type) {
                this.$nextTick(() => {
                    this.$store
                        .dispatch("fetchModules", {
                            url: "modules/" + this.login_type + "/permission/templates",
                            method: "get",
                        })
                        .then((data) => {
                            this.currentTemplate = data.permissions_template;
                            this.allPermissions = this.currentTemplate.filter((mod) => {
                                return mod.permission_functions;
                            });

                            let filteredArray = [];
                            this.allPermissions.forEach((mod) => {
                                this.allPermissionsFiltered[mod.module_id] = [];
                                if (mod.permission_functions) {
                                    mod.permission_functions.forEach((permission) => {
                                        this.allPermissionsFiltered[mod.module_id].push({ value: permission.function_id, text: permission.permission });
                                        if (permission.user_functions_template) filteredArray.push(permission.function_id);
                                    });
                                    this.updatedPermissions[mod.module_id] = filteredArray.sort();
                                }
                                filteredArray = [];
                            });
                            this.permsToWatch = { ...this.updatedPermissions };
                            this.finishLoader();
                        });
                });
            } else {
                this.$store
                    .dispatch("fetchLoginType", {
                        url: "login_types",
                        method: "get",
                        stateProperty: "login_types",
                        dataProperty: "app_login_types",
                        commit: true,
                        localStorage: true,
                    })
                    .then((data) => {
                        if (typeof data != "undefined") {
                            this.finishLoader(true);
                        } else {
                            this.finishLoader();
                        }
                    });
            }
        },
        checkIfChanged() {
            this.$nextTick(() => {
                for (const mod in this.updatedPermissions) {
                    this.updatedPermissions[mod].sort();
                }
                JSON.stringify(this.permsToWatch) === JSON.stringify(this.updatedPermissions) ? (this.changed = false) : (this.changed = true);
            });
        },
        undoPermissionChanges() {
            this.updatedPermissions = { ...this.permsToWatch };
            this.changed = false;
        },
        updatePermissions() {
            this.startLoader();
            let body = {
                permission_functions: [],
            };

            this.currentPermissions.filter(() => {
                return true;
            });

            for (const mod in this.updatedPermissions) {
                let updatedMod = {
                    function_id: this.updatedPermissions[mod],
                };
                body.permission_functions.push(updatedMod);
            }

            this.$store
                .dispatch("fetchModules", {
                    url: "modules/" + this.login_type + "/permission/templates",
                    method: "post",
                    body: body,
                })
                .then((data) => {
                    this.getPermissionTemplate();
                    this.changed = false;
                });
        },
    },
};
</script>
